import { useState } from 'react'

export function useFormValidation(initialValues, validationRules) {
  const [values, setValues] = useState(initialValues)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)

  const validateField = (name, value) => {
    const rules = validationRules[name]
    if (!rules) return ''

    // Required validation
    if (rules.required && !value.trim()) {
      return rules.required
    }

    // Email validation
    if (rules.email && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(value)) {
        return rules.email
      }
    }

    // Phone validation
    if (rules.phone && value) {
      const phoneRegex = /^[\+]?[0-9\s\-\(\)]+$/
      if (!phoneRegex.test(value) || value.length < 10) {
        return rules.phone
      }
    }

    // Min length validation
    if (rules.minLength && value.length < rules.minLength.length) {
      return rules.minLength.message
    }

    // Max length validation
    if (rules.maxLength && value.length > rules.maxLength.length) {
      return rules.maxLength.message
    }

    return ''
  }

  const validateForm = () => {
    const newErrors = {}
    let isValid = true

    Object.keys(validationRules).forEach(fieldName => {
      const error = validateField(fieldName, values[fieldName] || '')
      if (error) {
        newErrors[fieldName] = error
        isValid = false
      }
    })

    setErrors(newErrors)
    return isValid
  }

  const handleChange = (name, value) => {
    setValues(prev => ({
      ...prev,
      [name]: value
    }))

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const handleBlur = (name, value) => {
    const error = validateField(name, value)
    setErrors(prev => ({
      ...prev,
      [name]: error
    }))
  }

  const handleSubmit = async (onSubmit) => {
    setIsSubmitting(true)
    
    if (validateForm()) {
      try {
        await onSubmit(values)
        // Reset form on successful submit
        setValues(initialValues)
        setErrors({})
      } catch (error) {
        console.error('Form submission error:', error)
      }
    }
    
    setIsSubmitting(false)
  }

  const reset = () => {
    setValues(initialValues)
    setErrors({})
    setIsSubmitting(false)
  }

  return {
    values,
    errors,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    reset,
    validateForm
  }
}
